import React, {
    ElementType,
    PropsWithChildren,
    MouseEvent
} from "react";

import {UsersStrongIcon } from 'src/monet/icons';
import { trackSegmentEvent } from 'src/utils/segment';

type Props = PropsWithChildren<{
    component?: ElementType;
    className?: string;
    align: string;
    position: string;
}>;

const AffiliateButton: React.FC<Props> = (props) => {
    const {
        component: Component = "button",
        align = "left",
        position = "bottom",
        children,
        ...rest
    } = props;


    return (
        <a
          href="https://affiliates.journey.io"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            trackSegmentEvent('Sidebar Item Clicked', {
              item: "Affiliate",
            })
          }}
          className="flex rounded-lg items-center transition-colors hover:bg-bedrock-light-gray text-bedrock-black p-2 bg-bedrock-white shrink-0 space-x-sm">
            <UsersStrongIcon className='w-4 h-4' />
            <span className='text-bedrock-p-strong' style={{marginTop:2}}>Affiliate Program</span>
        </a>
    );
};


export type {Props as AffiliateButtonProps};
export {AffiliateButton};